import { environment } from '../../../environments/environment';
import { finalize, tap } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerngxService implements HttpInterceptor {
  count = 0;
  excludedUrl: string[] = environment.excludedUrl;
  constructor(private spinner: NgxSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if (this.excludedUrl.some(x => (x === req.url) || (x === req.url.substring(0, 7)) || (x === req.url.substring(8, 31)) ||
    //   (x === req.url.substring(0, 8)))) {

    //   return next.handle(req);
    // }

    if (this.excludedUrl.some(x => (req.url.includes(x)))) {
      return next.handle(req);
    }
    this.spinner.show()
    this.count++;
    return next.handle(req)
      .pipe(tap(
        /*event => console.log(event),
        error => { console.log( error ) }*/
      ), finalize(() => {
        this.count--;
        if (this.count == 0) this.spinner.hide()
      })
      );
  }

}
